import { Component, OnInit, Input, Directive, ViewChild, AfterViewInit, ElementRef, 
  Renderer2, HostListener, ChangeDetectionStrategy, DoCheck, KeyValueDiffers, SimpleChanges, OnChanges, Output, EventEmitter } from '@angular/core';
import { NgbModal, NgbModalConfig, NgbDateStruct, NgbDateAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { HomeService } from '../_services/home.service';
import { FormBuilder, Validators, FormGroup, FormControl, NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Router, NavigationEnd } from '@angular/router';
import { AuthenticationService } from '../_services/index';
import { getTreeNoValidDataSourceError } from '@angular/cdk/tree';
import { MatIconModule } from '@angular/material/icon';
import { environment } from '../../environments/environment';
import { HttpClient, HttpEventType } from '@angular/common/http';
import icons from 'glyphicons';
// import { containsElement } from '@angular/animations/browser/src/render/shared';
export let mapObj = new Map;
import { Pipe, PipeTransform } from "@angular/core";
import moment from 'moment';
// import { TransitionCheckState } from '@angular/material';
// import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Location } from '@angular/common';

@Pipe({
  name: "sort"
})

export class CustomDateAdapter {
  fromModel(value: string): NgbDateStruct {
    if (!value)
      return null
    let parts = value.split('/');
    return { year: +parts[0], month: +parts[1], day: +parts[2] }
  }

  toModel(date: NgbDateStruct): string {
    return date ? date.year + "/" + ('0' + date.month).slice(-2)
      + "/" + ('0' + date.day).slice(-2) : null
  }
}

export class CustomDateParserFormatter {
  parse(value: string): NgbDateStruct {
    if (!value)
      return null
    let parts = value.split('/');
    return { year: +parts[0], month: +parts[1], day: +parts[2] } as NgbDateStruct

  }
  format(date: NgbDateStruct): string {
    return date ?  ('0' + date.month).slice(-2) + "/" + ('0' + date.day).slice(-2) + "/" + date.year  : null;
  }
}
class onSubmit {
  date: Date;
}


@Directive({
  selector: 'ngInit',
  exportAs: 'ngInit'
})
export class NgInit {
  @Input() values: any = {};
  @Input() optionField: string;

  @Input() ngInit;
  ngOnInit() {
    if (this.ngInit) { this.ngInit(); }
  }
}

@Component({
  selector: 'app-create-ticket',
  templateUrl: './create-ticket.component.html',
  styleUrls: ['./create-ticket.component.scss'],
  providers: [NgbModalConfig, NgbModal,
    { provide: NgbDateAdapter, useClass: CustomDateAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
  ]
})


export class CreateTicketComponent implements OnInit {
  field: any;
  datePickerConfig: any;
  qtd: Array<any>;
  changeDetection: ChangeDetectionStrategy.OnPush;
  caseform: FormGroup;
  ispopUpShow: boolean = false
  selectedOption: any;
  options: any;
  disableSubmit: any;
  option: Array<any>;
  fieldType: string;
  fieldTypes: Array<any>
  customerConfig: any = {}
  dependencies: Array<any>
  datas: Array<any>
  caseFieldWatch: Array<any>
  show_in_create: true;
  show_in_search: true;
  submitted: boolean = false;
  createCaseTitle: string;
  count: number;
  userpk: string;
  fields: [];
  showForm = true;
  showModal: boolean = true
  updateCaseFields: any = {}
  focused = {};
  closeResult = '';
  alert: boolean = false;
  isSticky: boolean = false;
  institutionId: string
  differ: any;
  error: any;
  dependencyField: Array<any>;
  defaultDateFormat: any;
  selectedId: any;
  files: Array<any> = []
  fileToUpload: any;
  file: { file_name: any; content_type: any; file_path: any; };
  i18n: any;
  storage: any;
  uploadedFiles: any;
  uploadedFile: [];
  progress: number
  file_size: number = 0;
  upload: any;
  status: boolean = false;
  file_length: number = 0;
  regexFile: boolean;
  regexFormat: string;
  selectedDate: any = '';
  emailAddresses: any;
  emailValid: boolean = false;
  totalFileExceed: boolean = false;
  current_upload_size: number = 0;
  UploadFailedMessage: boolean;
  SelectedFile: number;
  sizeExceededMessage: boolean;
  fileProgress: boolean = true;
  uploadedFileLength: any;
  UploadingFile: boolean;
  UploadedFileName: any;
  duplicateFiles: boolean = true;
  userFields: Array<any>;
  defaultValue: number[];
  defaultValues: any;
  maxDate = { year: new Date().getUTCFullYear() + 100, month: 1, day: 1 }
  minDate = { year: new Date().getUTCFullYear() - 100, month: 1, day: 1 }
  ticketFields: Array<any>;
  submitButtonLabel: "";
  closeButtonEnable: boolean = false;
  closeLabelText: "";
  caseUiTitle: any;
  caseWelcomeNote: any;
  needLogin: any;
  loggedIn: boolean;
  userFieldsConfig: Array<any>;
  @Output() checkIsCaseModalOpen = new EventEmitter();
  @Output() checkIsCaseModalOpenInHome = new EventEmitter();
  @Output() checkIsCaseModalOpenInHelpCenter = new EventEmitter();
  caseOfficeTime: any;
  caseMessage: any;

  @HostListener('window:scroll', ['$event'])
  checkScroll() {
    this.isSticky = window.pageYOffset >= 250;
  }

  @ViewChild('caseform') public userLoginForm: NgForm;

  @ViewChild('content') content;
  caseCreationSuccess: boolean;
  caseSuccesMsg: string;
  multiOption: boolean
  caseCreateIsFailed: boolean;
  caseFailureMsg: string;
  public alertMessage: any = {};
  errorMessage: string;
  checkId: any;
  modifiedText: string;
  value: any; dropdownSettings: { singleSelection: boolean; idField: string; textField: string; selectAllText: string; unSelectAllText: string; itemsShowLimit: number; allowSearchFilter: boolean; };
  requiredField: boolean;
  multiOptionField: boolean;
  constructor(
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private elRef: ElementRef, private renderer: Renderer2,
    private router: Router,
    private differs: KeyValueDiffers,
    private authService: AuthenticationService,
    private homeService: HomeService,
    private http: HttpClient,
    private _location: Location,
    config: NgbModalConfig,
    private modalService: NgbModal) {
    config.backdrop = 'static';
    config.keyboard = false;
    this.differ = this.differs.find({}).create();
  }

  ngOnInit() {
    this.homeService.getChatOfficeTime().subscribe(res => {
      this.caseOfficeTime = res.return_body.caseOfficeTime
    });
    this.homeService.getMessage().subscribe(ress => {
      this.caseMessage = ress.return_body.caseMessage
    });
    if (sessionStorage.getItem('i18n')) {
      this.i18n = JSON.parse(sessionStorage.getItem('i18n'));
    }
    mapObj.clear();
    this.caseform = this.fb.group({
    });
    this.createCaseTitle = this.i18n._value['shp.create.case'];
    this.initCustomerFieldsConfig()
    this.homeService.getCaseFields().subscribe(res => {
      this.fieldTypes = res.return_body
      for (let types of this.fieldTypes) {
        if (types.type == "OPTION") {
          if (types.value == null) {
            types.value = ""
          }
        }
        if (types.type == "DATE") {
          if (types.value == "") {
            types.value = null
          }
          else {
            types.value = (types.value).replaceAll('-', '/');
          }
        }
        if (types.type == "MULTIPLEOPTION") {
          if (types.value.length > 0) {
            let defalut = types.value.split(',').map(num => parseInt(num));
            types.value = defalut
          }
        }
      }
    })

    this.homeService.getTicketConfigurationFields().subscribe(res => {
      this.ticketFields = res.return_body
      console.log("TICKET FIELDS:", this.ticketFields);
      this.userFieldsConfig = res.return_body.userFieldsConfiguration
      this.needLogin = res.return_body.ticketCommonConfiguration.needLogin
      this.caseWelcomeNote = res.return_body.ticketCommonConfiguration.submitTicketTitle
      this.caseUiTitle = res.return_body.ticketCommonConfiguration.popupTicketName
      this.closeButtonEnable = res.return_body.ticketCommonConfiguration.closeLabelEnable
      this.closeLabelText = res.return_body.ticketCommonConfiguration.closeLabelText
      this.submitButtonLabel = res.return_body.ticketCommonConfiguration.submitTicketButtonLabel
      if ((this.needLogin == false) && (this.authService.isUserLoggedIn())) {
        this.openModal();
      }
      if ((this.needLogin == true) && (this.authService.isUserLoggedIn())) {
        this.openModal();
      }
      if ((this.needLogin == false) && (!this.authService.isUserLoggedIn())) {
        this.openModal();
      }
      if ((this.needLogin == true) && (!this.authService.isUserLoggedIn())) {
        // this.router.navigate([this.router.url.split("/")[1], 'login']);
        this.checkIsCaseModalOpen.emit({ checkModal: true });
        this.checkIsCaseModalOpenInHome.emit({ checkModal: true });
        this.checkIsCaseModalOpenInHelpCenter.emit({ checkModal: true });
        localStorage.setItem('showCreateCase', 'yes');
        this.authService.setValueInConfigAtLocalStorage('showCreateCaseModal', 'yes');
        /* unset autoOpenChatWindow */
        if (this.authService.getValueInConfigFromLocalStorage('autoOpenChatWindow') === 'yes') {
          this.authService.setValueInConfigAtLocalStorage('autoOpenChatWindow', 'no');
        }
        this.homeService.navigateToLogin(this.router.url);
      }
      if (this.authService.isUserLoggedIn()) {
        this.loggedIn = true;
      }
    })
  }
  timeout = environment.inactiveTimeOutMinutes;//minutes
  openModal() {
    setTimeout(() => {
      this.closeModal();
    }, this.timeout*1000*60);
    this.modalService.open(this.content);
  }

  closeModal() {
    this.modalService.dismissAll('Cross click')
    this.checkIsCaseModalOpen.emit({ checkModal: true })
    this.checkIsCaseModalOpenInHome.emit({ checkModal: true })
    this.checkIsCaseModalOpenInHelpCenter.emit({ checkModal: true })
    //  this._location.back()
    this.alert = true;
    localStorage.removeItem('showCreateCase');
  }
  onOptionSelected(optionId) {
    this.selectedOption = optionId.value
    this.selectedId = optionId.id
    if (optionId.value != null && optionId.value != '') {
      this.homeService.getNewDependency(optionId.value).subscribe(response => {
        this.dependencyField = response.return_body
        for (let types of this.dependencyField) {
          if (types.type == "OPTION") {
            if (types.value == null) {
              types.value = ""
            }
          }
          if (types.type == "DATE") {
            if (types.value == "") {
              types.value = null
            }
            else {
              types.value = (types.value).replaceAll('-', '/');
            }
          }
          if (types.type == "MULTIPLEOPTION") {

            if (types.value.length > 0) {


              let defalut = types.value.split(',').map(num => parseInt(num));

              types.value = defalut
            }
          }
        }
        this.fieldTypes = this.fieldTypes.concat(this.dependencyField)
      })
    }
  }

  onModelChange(event) {
    let old_option_id = mapObj.get(event.id)
    if (mapObj.get(event.id)) {
      if ((mapObj.get(event.id) != event.value)) {
        this.deleteOldDependenceFields(this.institutionId, "", old_option_id, null, event.id, event.value, false);
      }
    }
    mapObj.set(event.id, event.value);

  }

  deleteOldDependenceFields(institutionId, token, old_option_id, oldDependenceField, field_id, new_field_id, isNested) {
    if (old_option_id != null && old_option_id != '') {
      var configData = {
        'institutionId': this.institutionId,
        'token': token,
        'field_id': field_id,
        'new_option_id': new_field_id,
        'isNested': isNested
      };
      this.homeService.getDependencyTemplate(old_option_id, configData).subscribe(res => {
        this.dependencies = res.return_body
        for (let oldId of this.dependencies) {
          let index = this.fieldTypes.findIndex(obj => obj['id'] === oldId.id)
          this.fieldTypes.splice(index, 1)

        }
      })
    }
  };
  sortBy(prop: string) {
    return this.fieldTypes.sort((a, b) => a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1);
  }
  sort(prop: string) {
    return this.userFieldsConfig.sort((a, b) => a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1);
  }

  @HostListener('keyup', ['$event'])
  onKeypressEvent(event: KeyboardEvent, myField) {
    let ev = event.which ? event.which : event.keyCode
    if ((ev >= 48 && ev <= 57) || ev == 8 || ev == 45) {
      if (ev == 45) {
        if (myField.value == "") {
          return true;
        } else {
          return false;
        }
      }
      return true;
    } else {
      return false;
    }
  }

  checkStatus(id) {
    this.focused[id] = true;
    this.checkId = id;
  }
  initCustomerFieldsConfig() {
    this.homeService.getCustomerConfig().subscribe(res => {
      this.customerConfig = res.return_body
      this.userFields = this.customerConfig.userFieldsFields
    })
  }

  validEmail(email) {
    var re = new RegExp("/^[\\-\w+.%]+@[\w\\-.]+\.[A-Za-z]{2,4}$/");
    re.test(email);
    let emails = email.split(',');

    let invalidEmails = [];

    for (let i = 0; i < emails.length; i++) {
      if (!(emails[i].trim())) {
        invalidEmails.push(emails[i].trim())
      }
    }

  }
  convertFieldsValue(field) {
    if ((field.type == 'OPTION') && (field.value != null) && (field.value != '')) {
      let optionValue = field.value;
      if (Number(optionValue) > 0) {
        field.value = Number(optionValue);
      }
    } else if (field.type == 'DATE') {
      if (field.value) {
        if (field.value.match(/^\d*$/g)) {
          field.value = new Date(Number(field.value));
        } else {
          field.value = new Date(field.value);
        }
      }

    } else if ((field.type == 'MULTIPLEOPTION') && (field.value != null) && (field.value != '')) {
      field.value = field.value.split(",");
      if (field.options != null) {
        for (let option of this.field) {
          option.id = option.id + "";
        };
      }
    } else if ((field.type == 'INTEGER') && (field.value != null) && (field.value != '')) {
      field.value = Number(field.value);
    }
  }

  getContactID() {
    return this.userpk = this.authService.getCurrentUserPK();//localStorage.getItem('pk');
  }

  getContactData() {
    let data = [];
    for (let contact of this.userFieldsConfig) {
      if (contact != '') {
        this.field = {
          user_field_name: contact.fieldName,
          display_name: contact.displayName,
          user_field_value: contact.runTimeVariableValue
        }
      }
      data.push(this.field)
    }
    return data
  }
  getTicketData() {
    let data = [];
    for (let fields of this.fieldTypes) {
      if (fields != '') {
        if (fields.type === 'MULTIPLEOPTION' && fields.value != null) {
          let multipleOptions = fields.value;
          let result = '';
          for (let option of multipleOptions) {
            if (option != null && option != '') {
              if (result === '') {
                result = option;
              } else {
                result += ',' + option;
              }
            }

            this.field = {
              id: fields.id,
              label: fields.name,
              value: result,
            };
          }
        }
        else
          if (fields.type === 'DATE' && fields.value != null) {
            var date = new Date(fields.value);
            var formatted = moment(date).format('YYYY-MM-DD');
            this.field = {
              id: fields.id,
              label: fields.name,
              value: formatted
            };
          }
          else {
            this.field = {
              id: fields.id,
              label: fields.name,
              value: fields.value,
            };
          }
      }
      data.push(this.field)
    }
    return data

  }

  closeAlert() {
    setTimeout(() => {
      this.closeModal();
    }, 5000);
    this.alert = false;
    this.router.navigate(['/home']);
  }

  remove(file) {
    let index = this.files.indexOf(file)
    this.files.splice(index, 1)
    this.file_size = this.file_size - file.size
    this.file_length = this.file_length - 1
    this.status = false
    this.regexFile = false
    this.sizeExceededMessage = false
    this.UploadFailedMessage = false
    this.UploadingFile = false
    this.duplicateFiles = true

  }

  handleFileInput(event) {
    this.duplicateFiles = true
    let files = []
    let file_length = 0
    let isUploaded = false
    this.file_length = this.file_length + event.target.files.length
    for (let i = 0; i < event.target.files.length; i++) {
      this.file_size = this.file_size + event.target.files[i].size
      this.current_upload_size = this.current_upload_size + event.target.files[i].size
      this.UploadedFileName = event.target.files[i].name
      if (this.files) {
        for (let fileUploaded of this.files) {
          if (fileUploaded.name === event.target.files[i].name) {
            this.duplicateFiles = false
          }
        }
      }

      let regex = new RegExp('[*\\\\?\":{}|/<>]');
    }
    if (this.duplicateFiles) {
      if (this.file_size < 20 * 1024 * 1024) {
        if (this.file_length < 6) {
          for (let i = 0; i < event.target.files.length; i++) {
            let regex = new RegExp('[*\\\\?\":{}|/<>]');
            if (regex.test(event.target.files[i].name)) {
              this.file_length = this.file_length - event.target.files.length
              this.file_size = this.file_size - this.current_upload_size
              this.status = false;
              this.UploadFailedMessage = false
              this.sizeExceededMessage = false
              this.fileProgress = true
              this.regexFile = true
              this.UploadingFile = false
              this.regexFormat = "*?\\\":{}|/<>"
              break
            }

            if ((this.file_size < 20 * 1024 * 1024) && (this.file_length < 6) && (this.UploadedFileName.length <= 100)) {

              files.push(event.target.files[i]);
              this.regexFile = false
              isUploaded = true
              this.uploadedFileLength = event.target.files.length
              this.UploadingFile = true
              this.sizeExceededMessage = false
              this.UploadFailedMessage = false
              this.fileProgress = false
            }

            else if (this.file_size > 20 * 1024 * 1024) {
              isUploaded = false
              alert("All files cannot exceed 20MB")
            }
            else if (this.file_length >= 6) {
              isUploaded = false
              alert("Upload Files(max 5)")
            }
            else if (this.UploadedFileName.length > 100) {
              isUploaded = false
            }


            if (!isUploaded) {
              this.regexFile = false
              this.status = false;
              this.file_size = this.file_size - this.current_upload_size
              this.file_length = this.file_length - 1
            }
            else {
              let institutionId = this.homeService.institutionId
              const attachmentUrl = environment.api_vi + institutionId + environment.fileUpload
              const formdata = new FormData();
              for (let i = 0; i < files.length; i++) {
                formdata.append("file", files[i]);
                for (let fileName of files) {
                  this.UploadedFileName = fileName.name
                }
                this.http.post(attachmentUrl, formdata, {
                  reportProgress: true,
                  observe: 'events'
                }).subscribe(event => {
                  if (event.type === HttpEventType.UploadProgress) {
                    this.status = true;
                    this.progress = Math.round(event.loaded / event.total * 100)
                  } else if (event.type === HttpEventType.Response) {
                    this.fileProgress = true
                    this.UploadingFile = false
                    this.progress = 0;
                    this.status = false;
                  }
                })
                this.files = this.files.concat(files[i])
                files = []
              }

            }
          }
        }
        else {
          this.file_length = this.file_length - event.target.files.length
          this.file_size = this.file_size - this.current_upload_size
          this.UploadFailedMessage = true
          this.sizeExceededMessage = false
          this.fileProgress = true
          this.UploadingFile = false
          this.regexFile = false
        }
      }
      else {
        this.file_size = this.file_size - this.current_upload_size
        this.file_length = this.file_length - event.target.files.length
        this.sizeExceededMessage = true
        this.UploadFailedMessage = false
        this.fileProgress = true
        this.UploadingFile = false
        this.regexFile = false
      }
    }
    else {
      this.file_size = this.file_size - this.current_upload_size
      this.file_length = this.file_length - event.target.files.length
      this.sizeExceededMessage = false
      this.UploadFailedMessage = false
      this.fileProgress = true
      this.UploadingFile = false
      this.regexFile = false
    }
    this.current_upload_size = 0
  }


  getAttachmentData() {
    let data = [];
    if (this.files) {
      for (var i = 0; i < this.files.length; i++) {
        this.field = {
          file_name: this.files[i].name,
          content_type: this.files[i].type,
          file_path: this.files[i].file_path
        }
        data.push(this.field)
      }
      return data
    }
  }
  onSubmit(data: NgForm) {
    console.log('logged in ?',this.authService.isUserLoggedIn())
    this.selectedDate = data.value.datepicker
    this.submitted = true;
    this.updateCaseFields = {
      contact_id: this.getContactID(),
      contact_info: this.getContactData(),
      values: this.getTicketData(),
      attachment: this.getAttachmentData(),
      needLogin : this.needLogin
    };
    this.homeService.postCaseFields(this.updateCaseFields).subscribe(response => {
      if (response.return_body != null) {
        var joinedArray = response.return_body;
        var number = joinedArray.split(/(\d+)/);
        let caseValue = number.slice(1, 4).join("");
        this.alertMessage = "Case saved successfully, case number is " + caseValue;
        this.caseCreationSuccess = true;
        setTimeout(() => {
          this.closeModal();
        }, 5000);
      }
      else {
        this.errorMessage = response.error_msg;
        this.caseCreateIsFailed = true;
        setTimeout(() => {
          this.closeModal();
        }, 5000);
      }
    },
      error => {
        this.caseCreateIsFailed = true;
        if (error.status == 401) {
          this.errorMessage = "Sorry, you are not allowed to perform this action.";
        } else if(error ==="Case not created") {
          this.errorMessage = "Case not created. Please login to create a Case.";
        }else {
          this.errorMessage = "We are not able to process your request. Please try again.";
        }
        setTimeout(() => {
          this.closeModal();
        }, 5000)
        this.modalService.dismissAll('Cross click')
      }
    );
    data.reset();
    this.alert = true;
  }
}




